import { Card, Space } from 'antd'
import _ from 'lodash'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'

import RoleItem from '../RoleItem'

import Styled from './styled'

export default function Role({ value, onChange }) {
  const filterRoles = useStoreState((state) => state.filter.roles)

  const getFilterRoles = useStoreActions((actions) => actions.filter.getRoles)

  useAsync(async () => {
    getFilterRoles()
  }, [])

  return (
    <Styled className="role-component">
      <Card size="small">
        <Space wrap>
          {_.map(filterRoles, (role, index) => {
            const isActive = role.id === value
            return (
              <div key={index} className="role-item">
                <RoleItem
                  name={role.name}
                  checked={isActive}
                  onChange={() => {
                    onChange(role.id)
                  }}
                />
              </div>
            )
          })}
        </Space>
      </Card>
    </Styled>
  )
}
